export const modifierKeys: string[] = ['control', 'shift', 'alt', 'meta'] as const;
